module.exports = __webpack_public_path__ + "static/media/silver_signet_ring_round_blue_layered_agate_hand_engraved_result.e9afcfcd.jpg";